import React, {useState, useEffect} from "react";
import PropTypes from 'prop-types';
import SoftBox from "../../../../components/SoftBox";
import i18n from "../../../../config/i18n";
import {useTranslation} from 'react-i18next';
import {
    Box,
    RadioGroup,
    FormControlLabel,
    Radio,
    TextField
} from "@mui/material";
import {parseCustomPageRange} from "../../../../utlis/generalUtils";

const PageSelector = ({option, setOption, pageRange, setPageRange, numberOfPage}) => {
    const {t} = useTranslation(['regenerateServices']);
    const lang = i18n.language;
    const direction = i18n.dir();
    const [errors, setErrors] = useState("");

    useEffect(() => {

        if (option !== "range") {
            return;
        }
        const { isValid: valid, error: customError } = parseCustomPageRange(pageRange, numberOfPage, t);

        setErrors(customError);
        setPageRange(pageRange, valid)
    }, [option]);
    const updatePageRange = (e) => {

        let range = e.target.value;
        const { isValid: valid, error: customError } = parseCustomPageRange(range, numberOfPage, t);
        setErrors(customError);
        setPageRange(range, valid)
    }

    return (
        <SoftBox
            sx={{
                pr: (direction === 'rtl' ? 3 : 0),
                pl: direction === 'rtl' ? 0 : 3,
            }}
        >
            <RadioGroup
                value={option}
                onChange={setOption}
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
                    mt: 1,
                }}
            >
                <FormControlLabel value="current"
                    control={<Radio sx={{
                        mr: (direction === 'rtl' ? 0 : 1),
                        ml: direction === 'rtl' ? 1 : 0,
                    }}/>}
                    label={t("options.current")}
                />
                <FormControlLabel value="all" control={
                    <Radio sx={{
                        mr: (direction === 'rtl' ? 0 : 1),
                        ml: direction === 'rtl' ? 1 : 0,
                    }}/>}
                    label={t("options.all")}
                />
                <FormControlLabel value="range"
                    control={<Radio sx={{
                        mr: (direction === 'rtl' ? 0 : 1),
                        ml: direction === 'rtl' ? 1 : 0,
                    }}/>}
                    label={t("options.range")}
                />
            </RadioGroup>

            {option === "range" && (
                <Box display="flex" gap={2} mt={1} alignItems="flex-start">
                    <Box sx={{display: "flex", flexDirection: "column"}}>
                        <TextField
                            id="page-custom"
                            type="text"
                            size="small"
                            value={pageRange}
                            onChange={updatePageRange}
                            error={!!errors}
                            helperText={errors}
                            fullWidth
                        />
                        <small style={{fontSize: "10px"}}>
                            {t("rangeHint")}
                        </small>
                    </Box>
                </Box>
            )}
        </SoftBox>
    );
};

PageSelector.propTypes = {
    option: PropTypes.string,
    setOption: PropTypes.func,
    pageRange: PropTypes.string,
    setPageRange: PropTypes.func,
    numberOfPage: PropTypes.number
};

export default PageSelector;
